import React from 'react';
import PropTypes from 'prop-types';

import { Search } from 'tabler-icons-react';
import { Input } from 'semantic-ui-react';

import './CommonSearchInput.css';

// For customising pass additional classes to 'options' prop.
// For example " options='rounded grey' " to set grey background or rounded corders or both.

const CommonSearchInput = (props) => {
  const {
    placeholder,
    className,
    onChange,
    options,
  } = props;

  return (
    <Input
      {...props}
      placeholder={placeholder}
      onChange={onChange}
      className={`common-search-field-input ${className} ${options}`}
      fluid
      icon={
        <i aria-hidden={true} className="icon">
          <Search size={18} />
        </i>
      }
      iconPosition="left"
    />
  );
};

CommonSearchInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.string,
};
CommonSearchInput.defaultProps = {
  placeholder: null,
  onChange: null,
  className: '',
  options: '',
};

export default CommonSearchInput;
